import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import { BreadcrumbOverrideHandle, BreadcrumbOverrideService, MessageComponent, MessageType, WINDOW } from '@sfcu/sfc-front-starter';
import { BtnRetourComponent } from '../btn-retour/btn-retour.component';

@Component({
    selector: 'app-generic-message',
    templateUrl: './generic-message.component.html',
    standalone: true,
    imports: [MessageComponent, BtnRetourComponent]
})
export class GenericMessageComponent implements OnInit {
    // Les Inputs restent pour l'utilisation directe sous forme de balise HTML
    @Input() type: MessageType = MessageType.KO; // Valeur par défaut
    @Input() title: string = "Une erreur est survenue"; // Valeur par défaut
    @Input() description?: string;
    @Input() titrePage? : string;

    private readonly breadcrumbOverride = inject(BreadcrumbOverrideService);
    private breadCrumb?: BreadcrumbOverrideHandle;

    protected readonly MessageType = MessageType;

    constructor(@Inject(WINDOW) private window: Window) {}

    ngOnInit(): void {
        // Si le composant a été appelé via une redirection de Route (ex: navigation.state)
        // on récupère les données masquées transmises dans l'historique du navigateur
        const navigationState = this.window.history?.state;

        if (navigationState) {
            this.type = navigationState.type || this.type;
            this.title = navigationState.title || this.title;
            this.description = navigationState.description || this.description;
            this.titrePage = navigationState.titrePage || this.titrePage;
        }

        if (this.titrePage) {
            this.breadCrumb = this.breadcrumbOverride.push(this.titrePage);
        }
    }
}
